import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { api, onForceLogout } from '@/lib/api';

const AuthContext = createContext(null);

export const useAuth = () => {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used within AuthProvider');
  return ctx;
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchUser = useCallback(async () => {
    if (!api.isLoggedIn()) { setUser(null); setLoading(false); return; }
    try {
      const me = await api.getMe();
      setUser(me);
    } catch {
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { fetchUser(); }, [fetchUser]);

  useEffect(() => {
    return onForceLogout(() => { setUser(null); });
  }, []);

  const login = async (data) => {
    await api.login(data);
    await fetchUser();
  };

  const signup = async (data) => {
    await api.signup(data);
    await fetchUser();
  };

  const logout = () => {
    api.logout();
    setUser(null);
  };

  const refreshUser = async () => {
    try { const me = await api.getMe(); setUser(me); } catch {}
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, signup, logout, refreshUser }}>
      {children}
    </AuthContext.Provider>
  );
};
